<template>
  <div class="team-m">
    <div class="tm-1">
      <img src="https://gwsite-1302681310.cos.ap-beijing.myqcloud.com/assets/h5/team/banner.png" width="100%"/>
    </div>
    <div class="tm-2">
      <div class="title-g">
        <p class="title">核心高管</p>
        <div class="line"></div>
        <h3>王森华 CEO 创始人</h3>
        <p content="detail">北京航空航天大学博士，专注于互联网大数据。资深互联网从业者，多年的国内著名企业管理经验，一直在TOP的互联网企业担任高级管理者。在商业模式创新、互联网平台架构设计、
          产业互联网创新、互联网公司运营方面有资深的专业经验。曾任职于民生银行、去哪儿网、 滴滴出行、运满满。</p>
        <!--        <h3>邓新 COO 专业运输</h3>
                <p content="detail">高级物流师
                  ，16年大件及工程物流行业经验。2008年创办4A级大件物流公司，年产值过亿。获得1项发明专利，10项实用新型专利，2项软件著作权。两项软著为运输行业的车辆转弯半径、爬坡度以及牵引力的精确验算提供依据，被广泛应用于各类大型物件运输项目中，提高了运输安全系数，实现了经济效益，推动了大件运输行业的技术升级。</p>
                -->
        <h3>李梓慧 CMO 首席营销官</h3>
        <p content="detail">南京大学本科
          ，18年销售管理经验，历任富士康商务部经理、苏州奥迪大客户总监。2015年加入智通三千，联合创始人、董事、任全国招商总经理（副总裁），三年多的时间布局线下900多个分公司。销售、管理领域有丰富的经验。</p>
      </div>
    </div>
    <div class="tm-3">
      <div class="title-g">
        <p class="title">团队照片</p>
        <div class="line"></div>
      </div>
      <div class="content">
        <el-carousel :interval="8000" type="card" arrow="never" ref="pro3" direction="horizontal">
          <el-carousel-item v-for="(item, index) in imgList" :key="index">
            <img :src="item" width="100%" @click="showBigImage(item)" style="cursor: pointer;"/>
          </el-carousel-item>
        </el-carousel>
        <el-row :gutter="12">
          <el-col :span="12">
            <i class="el-icon-arrow-left icon-diy" @click="arrowClick"/>
          </el-col>
          <el-col :span="12">
            <i class="el-icon-arrow-right icon-diy" @click="arrowClick('right')"/>
          </el-col>
        </el-row>
      </div>
    </div>
    
    <!-- 查看大图对话框 -->
    <el-dialog
      title="团队照片"
      :visible.sync="dialogVisible"
      width="90%"
      :close-on-click-modal="true"
    >
      <img :src="currentImage" width="100%"/>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "teamM",
  data() {
    return {
      imgList: [
        'https://gwsite-1302681310.cos.ap-beijing.myqcloud.com/assets/team/l1.jpg',
        'https://gwsite-1302681310.cos.ap-beijing.myqcloud.com/assets/team/l2.jpg',
        'https://gwsite-1302681310.cos.ap-beijing.myqcloud.com/assets/team/l3.jpg',
        'https://gwsite-1302681310.cos.ap-beijing.myqcloud.com/assets/team/l4.jpg',
        'https://gwsite-1302681310.cos.ap-beijing.myqcloud.com/assets/team/l5.jpg',
        'https://gwsite-1302681310.cos.ap-beijing.myqcloud.com/assets/team/l6.jpg',
        'https://gwsite-1302681310.cos.ap-beijing.myqcloud.com/assets/team/l7.jpg',
        'https://gwsite-1302681310.cos.ap-beijing.myqcloud.com/assets/team/l8.jpg',
      ],
      dialogVisible: false,
      currentImage: ''
    }
  },
  methods: {
    
    arrowClick(val) {
      console.log('1212');
      if (val === 'right') {
        this.$refs.pro3.next();
      } else {
        this.$refs.pro3.prev();
      }
    },
    
    showBigImage(imageUrl) {
      this.currentImage = imageUrl;
      this.dialogVisible = true;
    }
  }
}
</script>

<style lang="less">
.team-m {

  .title-g {
    margin-top: 55px;
    text-align: center;
    margin-bottom: 28px;

    .title {
      font-size: 22px;
      font-weight: 800;
      color: #222222;
      line-height: 30px;
      letter-spacing: 1px;
    }

    .line {
      width: 18px;
      height: 1px;
      background: #0274F6;
      display: inline-block;
      margin-top: 5px;
      margin-bottom: 8px;
    }

    .detail {
      text-align: left;
      font-size: 14px;
      font-weight: 500;
      color: #222222;
      line-height: 20px;
      letter-spacing: 1px;
    }
  }

  .tm-2 {
    padding: 0 18px;
  }

  .tm-3 {
      padding: 0 18px 30px 18px;

      .el-carousel {
        height: auto !important;
        min-height: 200px;
        touch-action: pan-x;
      }

    .el-carousel__container {
      height: auto !important;
    }

    .el-carousel__item {
      height: auto !important;
    }

    .el-carousel__item img {
      height: auto !important;
      object-fit: cover;
    }

    .el-carousel__indicators--outside {
      display: none;
    }
  }
}
</style>